module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bg-img-hero g-pos-rel",
    staticStyle: {
      "background-image": "url(/static/assets/include/svg/svg-bg-cfs.svg)"
    }
  }, [_c('div', {
    staticClass: "container g-pt-100"
  }, [_c('div', {
    staticClass: "row justify-content-lg-between"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 align-self-end"
  }, [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": _vm.charitable_outreach_img,
      "alt": "Image Description"
    }
  })])])]), _vm._v(" "), _c('svg', {
    staticClass: "g-pos-abs g-bottom-0",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 1921 183.5",
      "enable-background": "new 0 0 1921 183.5",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M0,183.5v-142c0,0,507,171,1171,58c0,0,497-93,750,84H0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": "0.2",
      "fill": "#FFFFFF",
      "d": "M0,183V0c0,0,507,220.4,1171,74.7c0,0,497-119.9,750,108.3H0z"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 g-pt-50--lg"
  }, [_c('div', {
    staticClass: "mb-5"
  }, [_c('h1', {
    staticClass: "g-font-size-38 mb-4"
  }, [_vm._v("Enhance Your Charitable Outreach")]), _vm._v(" "), _c('p', {
    staticClass: "frame-heading-description"
  }, [_vm._v("\r\n              Champions for Sight® offers a frame collection kit for every account! \r\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "frame-heading-description"
  }, [_vm._v("\r\n              Request your frame collection kit, which includes samples of every style, for a nominal donation.\r\n            ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ca518934", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca518934"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/frameResources/frameComponents/FrameHeader.vue
// module id = 572
// module chunks = 4